import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DefaultUrls } from 'src/assets/default.urls';
import { AuthService } from '../services/auth/auth.service';
import { DASHBOARD_PAGE_VIEW_MODE_STORAGE_KEY, DASHBOARD_THINGIES_OR_DEVICES_PAGE_STORAGE_KEY, getDashboardSetting } from './dashboard-helper';

export function DashboardGuard(): CanActivateFn {
  return () => {
    const oauthService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    void oauthService.getCurrentUserId().then((currentUserID) => {
      let thingiesOrDevices: string = getDashboardSetting(currentUserID, DASHBOARD_THINGIES_OR_DEVICES_PAGE_STORAGE_KEY) || 'thingies';
      if (thingiesOrDevices !== 'devices') {
        let dashboardPageMode = getDashboardSetting(currentUserID, DASHBOARD_PAGE_VIEW_MODE_STORAGE_KEY) || 'cards';
        return router.navigate([DefaultUrls.route.dashboardMode(dashboardPageMode)]);
      } else {
        return router.navigate([DefaultUrls.route.devices]);
      }
    });

    return false;
  };
}
